// extracted by mini-css-extract-plugin
export default {"home":"Home_home__CMw1J","section":"Home_section__uZuiO","sectionTitle":"Home_sectionTitle__SOFgZ","about":"Home_about__28DcV"};